// ansible-runner output under -v is full of colour escapes. One regex is not
// worth a dependency, and it is applied at render time so the raw text stays
// intact in the database.
const ANSI = /\u001B(?:[@-Z\\-_]|\[[0-?]*[ -\/]*[@-~])/g;

export const stripAnsi = (text: string): string => text.replace(ANSI, '');
